import * as React from 'react';
import { IRestListCommonActivity } from '../../../../../../../../types/rest/activity/IRestListCommonActivity';
import { IActivityProps } from '../../types';
import { TActivity } from '../../../../../../../../store/activities/types';
import { ActivityItemBody } from '../ActivityItemBody/ActivityItemBody';
import { ActivityHeader } from '../ActivityHeader/ActivityHeader';
import { AnalyzeRender } from '../../../../../../helpers/memoizeHelper';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`ListActivityArchive`) : null;

export function ListActivityArchive ({
    activity
}: IActivityProps<IRestListCommonActivity>) {
    if (analyzeRender) analyzeRender.call(activity.id);
    const { label } = activity as TActivity;
    return (
        <ActivityItemBody
            header={<ActivityHeader label={label} activity={activity} />}
            activity={activity}
        />
    );
}
